import {
  FieldLabel,
  getDropdownField,
  getNumberInputField,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from 'app/pages/admin/components/AdminFormComponents';
import { useFormikContext } from 'formik';
import {
  SmsPackageOptions,
  SmsPackageOptionsDefault,
} from 'lib/const/SmsPackageOptions';
import { SuperAdminCustomerDetails } from 'lib/context';
import React from 'react';

export const SmsLimitsSection = () => {
  const { isSubmitting, values, setFieldValue } =
    useFormikContext<SuperAdminCustomerDetails>();

  return (
    <Section style={{ paddingTop: '0.5rem' }}>
      <SectionTitle>Limits</SectionTitle>
      <RowWrapper>
        <Row>
          <FieldLabel>Free SMS per month</FieldLabel>
          {getNumberInputField('freeSmsPerMonth', true, false, isSubmitting)}
        </Row>
        <Row>
          <FieldLabel>Paid SMS per month</FieldLabel>
          {getDropdownField(
            'paidSmsPerMonth',
            'Select a package',
            SmsPackageOptions,
            values.paidSmsPerMonth ?? SmsPackageOptionsDefault,
            option => setFieldValue('paidSmsPerMonth', option.value)
          )}
        </Row>
      </RowWrapper>
    </Section>
  );
};
